export default __webpack_public_path__ + "static/media/С-21.ee281a7e.png";